import React from 'react';
import { CreditCardIcon } from '@heroicons/react/24/outline';

const SavedPaymentMethodsSelector = ({
  savedPaymentMethods = [],
  selectedSavedMethod,
  useNewCard,
  onSelectedMethodChange,
  onUseNewCardChange,
  disabled = false
}) => {
  const handleMethodChange = (methodId) => {
    if (methodId === 'new-card') {
      onUseNewCardChange(true);
      onSelectedMethodChange(null);
    } else {
      onUseNewCardChange(false);
      const method = savedPaymentMethods.find(m => m.id.toString() === methodId);
      onSelectedMethodChange(method);
    }
  };

  if (!savedPaymentMethods.length) {
    return null;
  }

  const BRAND_TEAL = '#14b8a6';

  return (
    <div style={{ marginBottom: 24 }}>
      <h3 style={{ fontSize: 18, fontWeight: 500, color: '#111827', marginBottom: 16, margin: 0, paddingBottom: 16 }}>Payment Method</h3>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {savedPaymentMethods.map((method) => {
          const isSelected = !useNewCard && selectedSavedMethod?.id === method.id;
          return (
            <div
              key={method.id}
              role="radio"
              aria-checked={isSelected}
              tabIndex={0}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '12px 14px',
                border: `2px solid ${isSelected ? BRAND_TEAL : '#e5e7eb'}`,
                borderRadius: 10,
                cursor: disabled ? 'not-allowed' : 'pointer',
                backgroundColor: isSelected ? '#f0fdfa' : '#fff',
                transition: 'all 0.15s'
              }}
              onClick={() => !disabled && handleMethodChange(method.id.toString())}
            >
              {/* Custom Radio Button */}
              <div style={{ width: 18, height: 18, borderRadius: '50%', border: `2px solid ${isSelected ? BRAND_TEAL : '#d1d5db'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginRight: 12 }}>
                {isSelected && <div style={{ width: 10, height: 10, borderRadius: '50%', background: BRAND_TEAL }} />}
              </div>

              <div style={{ display: 'flex', alignItems: 'center', flex: 1, margin: 0 }}>
                <CreditCardIcon style={{ height: 20, width: 20, color: isSelected ? BRAND_TEAL : '#9ca3af', marginRight: 12, flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ fontSize: 14, fontWeight: 500, color: '#111827' }}>
                      {method.cardBrand?.toUpperCase() || 'CARD'} •••• {method.last4}
                    </div>
                    {method.isDefault && (
                      <span style={{ marginLeft: 8, display: 'inline-flex', alignItems: 'center', padding: '2px 8px', borderRadius: 9999, fontSize: 12, fontWeight: 500, backgroundColor: BRAND_TEAL, color: '#fff' }}>
                        Default
                      </span>
                    )}
                  </div>
                  {method.expirationMonth && method.expirationYear && (
                    <div style={{ fontSize: 14, color: '#6b7280', marginTop: 4 }}>
                      Expires {method.expirationMonth.toString().padStart(2, '0')}/{method.expirationYear}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}

        {/* Use New Card Option */}
        <div
          role="radio"
          aria-checked={useNewCard}
          tabIndex={0}
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px 14px',
            border: `2px solid ${useNewCard ? BRAND_TEAL : '#e5e7eb'}`,
            borderRadius: 10,
            cursor: disabled ? 'not-allowed' : 'pointer',
            backgroundColor: useNewCard ? '#f0fdfa' : '#fff',
            transition: 'all 0.15s'
          }}
          onClick={() => !disabled && handleMethodChange('new-card')}
        >
          {/* Custom Radio Button */}
          <div style={{ width: 18, height: 18, borderRadius: '50%', border: `2px solid ${useNewCard ? BRAND_TEAL : '#d1d5db'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginRight: 12 }}>
            {useNewCard && <div style={{ width: 10, height: 10, borderRadius: '50%', background: BRAND_TEAL }} />}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', flex: 1, margin: 0 }}>
            <CreditCardIcon style={{ height: 20, width: 20, color: useNewCard ? BRAND_TEAL : '#9ca3af', marginRight: 12, flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: '#111827' }}>Use a new card</div>
              <div style={{ fontSize: 14, color: '#6b7280', marginTop: 4 }}>Enter new payment information</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SavedPaymentMethodsSelector;